<!-- Start Navbar Area -->
<div class="navbar-area">
  <div class="aronix-nav">
    <div class="container">
      <nav class="navbar navbar-expand-md navbar-light">
        <a class="navbar-brand" routerLink="/">
          <img src="assets/img/Enaiko6.png" alt="logo" />
        </a>

        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div
          class="collapse navbar-collapse mean-menu"
          id="navbarSupportedContent"
        >
          <ul class="navbar-nav">
            <li class="nav-item dropdown">
              <a
                routerLink="/"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                class="nav-link"
                >Home
              </a>
              <!--
                            <ul class="dropdown-menu">
                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="/" routerLinkActive="active"
                                        [routerLinkActiveOptions]="{exact: true}" class="nav-link">Home Default</a>
                                </li>

                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="/marketing-agency" routerLinkActive="active"
                                        class="nav-link">Marketing Agency</a>
                                </li>

                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="/digital-marketing" routerLinkActive="active" class="nav-link">Digital Marketing</a>
                                </li>

                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="/business-solutions" routerLinkActive="active" class="nav-link">Business Solutions</a>
                                </li>
                            </ul>
                        </li>
                        -->
            </li>

            <li class="nav-item dropdown">
              <a
                href="javascript:void(0)"
                class="nav-link dropdown-toggle"
                data-toggle="dropdown"
              >
                Services <i class="fas fa-chevron-down"></i>
              </a>

              <ul class="dropdown-menu">
                <!--   <li class="nav-item">
                                    <a routerLink="/services" routerLinkActive="active" class="nav-link">Services</a>
                                </li>  -->

                <li class="nav-item">
                  <a
                    routerLink="/service-details"
                    routerLinkActive="active"
                    class="nav-link"
                  >
                    Services Details
                  </a>
                </li>
              </ul>
            </li>
            <li class="nav-item">
              <a routerLink="/about" routerLinkActive="active" class="nav-link"
                >About</a
              >
            </li>
            <!--
            <li class="nav-item">
              <a
                routerLink="/pricing"
                routerLinkActive="active"
                class="nav-link"
                >Pricing</a
              >
            </li>
            -->  
            <!-- <style>
              .pointer {
                cursor: pointer;
              }
            </style>

            <li class="nav-item pointer">
              <a
                (click)="redirectToLogin()"
                routerLinkActive="active"
                class="nav-link"
                >Login</a
              >
            </li> -->

            <!--
                        <li class="nav-item dropdown">
                            <a href="javascript:void(0)" class="nav-link dropdown-toggle" data-toggle="dropdown">
                                Blog <i class="fas fa-chevron-down"></i>
                            </a>
                            <ul class="dropdown-menu">
                                <li class="nav-item">
                                    <a routerLink="/blog" routerLinkActive="active" class="nav-link">Blog</a>
                                </li>

                                <li class="nav-item">
                                    <a routerLink="/blog-details" routerLinkActive="active" class="nav-link">Blog
                                        Details</a>
                                </li>
                            </ul>
                        </li>

                        
                        
                        <li class="nav-item dropdown">
                            <a href="javascript:void(0)" class="nav-link dropdown-toggle" data-toggle="dropdown">
                                Projects <i class="fas fa-chevron-down"></i>
                            </a>
                            <ul class="dropdown-menu">
                                <li class="nav-item">
                                    <a routerLink="/projects" routerLinkActive="active" class="nav-link">Projects</a>
                                </li>

                                <li class="nav-item">
                                    <a routerLink="/project-details" routerLinkActive="active" class="nav-link">Projects Details</a>
                                </li>
                            </ul>
                        </li>

                       

                        <li class="nav-item dropdown">
                            <a href="javascript:void(0)" class="nav-link dropdown-toggle" data-toggle="dropdown">
                                Pages <i class="fas fa-chevron-down"></i>
                            </a>
                            <ul class="dropdown-menu">
                                <li class="nav-item">
                                    <a routerLink="/features" routerLinkActive="active"
                                        class="nav-link">Features</a>
                                </li>

                                <li class="nav-item">
                                    <a routerLink="/team" routerLinkActive="active" class="nav-link">Team</a>
                                </li>

                                <li class="nav-item">
                                    <a routerLink="/pricing" routerLinkActive="active"
                                        class="nav-link">Pricing</a>
                                </li>

                                <li class="nav-item">
                                    <a routerLink="/partner" routerLinkActive="active"
                                        class="nav-link">Partner</a>
                                </li>

                                <li class="nav-item">
                                    <a routerLink="/not-found" routerLinkActive="active" class="nav-link">404
                                        Error</a>
                                </li>

                                <li class="nav-item">
                                    <a routerLink="/faq" routerLinkActive="active" class="nav-link">FAQ</a>
                                </li>
                            </ul>
                        </li>

                        <li class="nav-item">
                            <a routerLink="/contact" routerLinkActive="active" class="nav-link">Contact</a>
                        </li>
                    </ul>

                    <div class="others-options">
                        <div class="option-item"><i class="search-btn flaticon-search"></i>
                            <i class="close-btn flaticon-close"></i>

                            <div class="search-overlay search-popup">
                                <div class='search-box'>
                                    <form class="search-form">
                                        <input class="search-input" name="search" placeholder="Search" type="text">

                                        <button class="search-button" type="submit"><i
                                                class="fas fa-search"></i></button>
                                    </form>
                                </div>
                            </div>
                        </div>

                        <div class="burger-menu">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    </div>
</div>
-->
            <!-- End Navbar Area -->
          </ul>
        </div>
      </nav>
    </div>
  </div>
</div>
